"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var INITIAL_STATE = {
	list: []
};

var FAILED_REGEX = new RegExp(/_FAILED$/);

var errors = function errors(state, action) {
	if (FAILED_REGEX.test(action.type)) {
		return { list: [].concat(_toConsumableArray(state.list || []), [action]) };
	} else {
		return state || INITIAL_STATE;
	}
};

exports.default = errors;